module.exports = __webpack_public_path__ + "static/orcus-d94929b602679bc0d0ff2bde4067572c.png";